/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var e;!function(e){e.MULTIPLIER="multiplier",e.ABSOLUTE="absoluteValue"}(e||(e={}));export{e as IdealEdgeLengthTypeOptions};
